import { useStyletron } from 'parkdepot-shared/theme'
import React, { FC, useContext, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

// components
import Button from 'parkdepot-shared/components/Buttons/Button'
import { BUTTON_KIND, BUTTON_SIZE } from 'parkdepot-shared/components/Buttons/types'
import { LotContext } from '../../../../context/LotContext/lot.context'
import { useIsLoggedIn } from '../../../../hooks/useAuth'
import { lotRouteSubscriptions } from '../../route'

interface NextButtonProps {
    isMobile: boolean
    translateKey?: string
    onCheckoutClick: () => void
}

const NextButton: FC<NextButtonProps> = ({ isMobile, translateKey = 'common.next', onCheckoutClick }) => {
    const { t } = useTranslation()
    const [css] = useStyletron()
    const [subscriptionDisabled, setSubscriptionDisabled] = useState<boolean>(false)
    const isLoggedIn = useIsLoggedIn()

    const { lot, nextDisabled, nextButtonLoading } = useContext(LotContext)

    useEffect(() => {
        // if route subscription and not logged in
        if (window.location.pathname === lotRouteSubscriptions(lot?.id) && !isLoggedIn) {
            setSubscriptionDisabled(true)
        }
    }, [lot])

    return (
        <div
            className={css({
                width: '100%',
                height: '5rem',
                marginTop: isMobile ? '0' : '5rem'
            })}
        >
            <Button
                id="continue-to-checkout-button"
                data-testid="continue-to-checkout-button"
                isLoading={nextButtonLoading}
                onClick={onCheckoutClick}
                disabled={subscriptionDisabled || nextDisabled}
                $size={BUTTON_SIZE.medium}
                $kind={BUTTON_KIND.primary}
                overrides={{
                    BaseButton: {
                        style: {
                            width: '100%'
                        }
                    }
                }}
            >
                <div>{t(subscriptionDisabled ? 'common.createAccountFirst' : translateKey)}</div>
            </Button>
        </div>
    )
}

export default NextButton
